import Maska from 'maska';
import { createApp } from 'vue';
import { createStore } from 'vuex';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { Tabs, Tab } from 'vue3-tabs-component';
import App from './App.vue';
import breakpoint from './global/breakpoint';
import Store from './store';

const store = createStore(Store);

createApp(App)
  .component('tabs', Tabs)
  .component('tab', Tab)
  .use(breakpoint)
  .use(Maska)
  .use(store)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app');
